<template>
  <div class="flex flex-col gap-4">
    <p v-if="!isValidBusinessSystemId" class="text-sm text-destructive">
      Invalid business system id.
    </p>
    <ChecklistTemplatesCard
      v-else
      edit-route="BdsChecklistTemplateEditPage"
      :redirect-to-edit-page-after-create="false"
      :checklist-templateable-id="businessSystemId"
      :checklist-templateable-type="checklistTemplateableType"
    />
  </div>
</template>

<script setup>

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ChecklistTemplatesCard from '../../../../../../checklists/resources/js/components/checklist-templates/ChecklistTemplatesCard.vue'

const route = useRoute()
const checklistTemplateableType = 'Umisis\\BusinessDocumentationSoftware\\Models\\BusinessSystem'
const businessSystemId = computed(() => Number(route.params.businessSystem ?? 0))
const isValidBusinessSystemId = computed(() => Number.isInteger(businessSystemId.value) && businessSystemId.value > 0)
</script>
